import { axiosInstance } from '@/repositories/fo-manual-API/Repository';
import { AuthRepository } from '@/repositories/fo-manual-API/IEntityRepository';

export default {
  resource: '/login',

  login(email: string, password: string) {
    return axiosInstance.post(`${this.resource}`, { email, password });
  },
} as AuthRepository;
